import type { Metadata } from "next";
import { ContactView } from "@/components/contact/contact-view";
import { site } from "@/content/site";

export const metadata: Metadata = {
  title: "Contact",
  description:
    "Talk to Quto AI about AI agents for voice, WhatsApp, chat and web. Tell us your use case and we'll show you how an agent would handle it.",
  alternates: { canonical: "/contact" },
  openGraph: {
    title: "Contact Quto AI",
    description: "Start a conversation with the Quto AI team.",
  },
};

export default function ContactPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: "Contact Quto AI",
    description:
      "Get in touch with Quto AI to design, build and deploy AI agents for your business.",
    publisher: {
      "@type": "Organization",
      name: site.name,
      url: site.url,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ContactView />
    </>
  );
}
